// Types
import { Skill, Education } from '@shared/types';
import { z } from 'zod';

// Schemas
import {
  employeeCertificationSchema,
  menteeSchema,
  supporteesSchema,
} from '@/schemas/employeeYearInReview';

export type EmployeeSkill = Skill;
export type EmployeeCertification = z.infer<typeof employeeCertificationSchema>;

export type Mentee = z.infer<typeof menteeSchema>;
export type Supportee = z.infer<typeof supporteesSchema>;

export interface EmployeeInfo {
  id?: string;
  name?: string;
  title?: string;
  avatar?: string;
  onboardedAt?: string;
}

export type EmployeeEducation = Omit<Education, 'admission' | 'graduation'> & {
  admission?: string;
  graduation?: string;
};

export interface EmployeeSupporter {
  name?: string;
  avatar?: string;
  email?: string;
}

export enum EmployeeTrainingStatus {
  IDLE = 'idle',
  IN_PROGRESS = 'in-progress',
  PAUSED = 'paused',
  RESUMED = 'resumed',
  COMPLETED = 'completed',
  ARCHIVED = 'archived',
}

export interface EmployeeTraining {
  id: string;
  topicLabel: string;
  supporters: EmployeeSupporter[];
  start?: string;
  actualEnd?: string;
  status?: EmployeeTrainingStatus;
}

/** Employee data for video rendering */
export interface Employee {
  info?: EmployeeInfo;
  skills?: EmployeeSkill[];
  education?: EmployeeEducation[];
  certs?: EmployeeCertification[];
  yearReviews?: { year: number; url: string }[];
  trainings?: EmployeeTraining[];
}
